import React from 'react';
import { getStatusIcon, getStatusStyle, statusLabel, resolveDisplayStatus } from '../../utils/callStatus';

const StatusBadge = ({ status, call, className = '' }) => {
  const resolved = call ? resolveDisplayStatus(call) : status;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset ${getStatusStyle(resolved)} ${className}`}
    >
      {getStatusIcon(resolved)}
      {statusLabel(resolved)}
    </span>
  );
};

export default StatusBadge;
